import { ascend, defaultTo, pipe, prop, toUpper } from 'ramda'

const firstnameProp = prop<'firstname', string | null>('firstname')

export const byName = ascend(pipe(firstnameProp, defaultTo('~'), toUpper))
